export default __webpack_public_path__ + "Gotham-Medium.woff";